import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth.service';
import { LoginResponse } from '@features/auth/models/auth.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isSubmitting = false;
  error: string | null = null;
  showPassword = false;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    // Si el usuario ya está autenticado, redirigirlo al dashboard
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/dashboard']);
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      return;
    }

    this.isSubmitting = true;
    this.error = null;

    const { email, password } = this.loginForm.value;
    
    this.authService.login(email, password).subscribe({
      next: (response: LoginResponse) => {
        this.isSubmitting = false;
        
        // Verificar si el usuario tiene permisos de administrador
        if (!this.authService.isAdminUser()) {
          // Si es un usuario customer, cerrar sesión y mostrar error
          this.authService.logout();
          this.error = 'Acceso denegado. Este panel es solo para administradores y personal autorizado.';
          return;
        }
        
        // Si tiene permisos, navegar al dashboard
        this.router.navigate(['/dashboard']);
      },
      error: (err: any) => {
        this.isSubmitting = false;
        this.error = 'Usuario o contraseña incorrectos';
        console.error(err);
      }
    });
  }
}
